import createStaticResourceAPI from "@/helpers/rtk_static_resource_factory";

const baseURL = process.env.REACT_APP_CORE_API + '/transactions/accessRequests';

export const accessRequestsAPI = createStaticResourceAPI({
  baseURL: baseURL,
  resource: "AccessRequests",
  tagTypes: ["AccessRequests"],
  idKey: "accessRequestId",
  lookupMap: ({ accessRequestId, referenceNo }) => ({
    value: accessRequestId,
    label: referenceNo
  }),
  customQuery: (query, { idKey, resource, baseURL }) => ({
    getListAccessRequestsForViewers: query(`${baseURL}/listForViewer`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) => {
        if (!result?.success || !Array.isArray(result.returnData)) {
          return [{ type: resource, id: "LIST" }];
        }

        return [
          ...result.returnData.map((item) => ({
            type: resource,
            id: item[idKey],
          })),
          { type: resource, id: "LIST" },
        ];
      }
    }),
  }),
  customMutations: (mutation, mutationOptions) => ({
    submitAccessRequests: mutation(`${baseURL}/submit`, mutationOptions("save")),
    returnAccessRequests: mutation(`${baseURL}/return`, mutationOptions("save")),
    approveAccessRequests: mutation(`${baseURL}/approve`, mutationOptions("save")),
    rejectAccessRequests: mutation(`${baseURL}/reject`, mutationOptions("save")),
    cancelAccessRequests: mutation(`${baseURL}/cancel`, mutationOptions("save")),
  }),
});

export const {
  useGetAccessRequestsQuery,
  useGetListAccessRequestsForViewersQuery,
  useExportAccessRequestsMutation,
  useFindAccessRequestsQuery,
  useLookUpAccessRequestsMutation,
  useSaveAccessRequestsMutation,
  useSubmitAccessRequestsMutation,
  useReturnAccessRequestsMutation,
  useApproveAccessRequestsMutation,
  useRejectAccessRequestsMutation,
  useCancelAccessRequestsMutation,
  useDeleteAccessRequestsMutation
} = accessRequestsAPI;
